import type { Question, Step } from '@de/types/types';

/**
 * Expands top-level `steps` so nested MULTI_QUESTION `stepQuestions` are included
 * as separate entries. Dependency resolution (`getOptionByCustomField`, cache keys)
 * looks up steps by `customField` / `id`; child questions are not always in the
 * top-level flow array, so they must be present in the list passed to dynamic-options
 * utilities.
 */
export function flattenStepsForDynamicOptions(steps: Step[]): Step[] {
  const result: Step[] = [];
  const seenIds = new Set<string>();

  const push = (s: Step) => {
    const id = s.id;
    if (id) {
      if (seenIds.has(id)) return;
      seenIds.add(id);
    }
    result.push(s);
  };

  for (const step of steps) {
    push(step);
    const nested = (step as Step & { stepQuestions?: Question[] })
      .stepQuestions;
    if (Array.isArray(nested)) {
      for (const child of nested) {
        push(child as Step);
      }
    }
  }

  return result;
}
